var CIDSerialiser = require('conversation/conversation-id-serialiser');

module.exports = {
    read : function(input) {
        var cid = CIDSerialiser.read(input);
        return { cid : cid };
    },
    write : function(output, req) {
        CIDSerialiser.write(output, req.cid);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-deregistration-request-serialiser.js
// module id = 1059
// module chunks = 1